import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { RightArrow } from "uikit/assets/icons";
import styles from "./OrganizationListItem.module.styl";
import { useTenantStorage } from "multitenancy/tenantStorage";
import { Heading } from "uikit/components";

export default function OrganizationListItem({ identifier, name, type }) {
    const history = useHistory();
    const location = useLocation();
    const state = location.state ?? null;
    const { setTenant } = useTenantStorage();

    const handleClick = async () => {
        await setTenant(identifier);
        history.push(state?.referrer ?? "/");
    };

    return (
        <div
            className={styles.organizationCard}
            data-test-name={identifier}
            onClick={() => void handleClick()}
        >
            <div className={styles.headerContainer}>
                <Heading size="h2" className={styles.header}>
                    {name}
                </Heading>
                <div className={styles.organizationType}>{mapType(type)}</div>
            </div>

            <RightArrow />
        </div>
    );
}

function mapType(type) {
    switch (type) {
        case "school":
            return "Спортивная организация";
        case "federation":
            return "Федерация";
        case "authority":
            return "Орган исполнительной власти";
        default:
            return "";
    }
}

OrganizationListItem.propTypes = {
    identifier: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};
